import { Component, Input, OnInit } from '@angular/core';
import { HelperService } from 'app/services';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-open-tab-link',
  templateUrl: './open-tab-link.component.html',
  styleUrls: ['./open-tab-link.component.scss'],
})
export class OpenTabLink implements OnInit {
  @Input() titleClass: string = '';
  @Input() title: string = '';
  @Input() tabId: string = '';
  @Input() link: string = '';
  @Input() showForHistory: boolean = false;
  @Input() reloadRequired: boolean = false;

  constructor(private helperService: HelperService) {}

  ngOnInit() {}

  openInSameTab() {
    this.helperService.openPageInSameTab(this.link, this.tabId);
    if (this.reloadRequired) {
      window.location.reload();
    }
  }

  openInExsistingTab() {
    this.helperService.openPageInNewExistingTab(this.link, this.tabId);
  }
}
